type Props = {
  height?: string | number;
  width?: string | number;
  onClick?: () => void;
};

export const SpeakerIcon = ({ height, width, onClick }: Props) => {
  const color = '#00d091';
  return (
    <svg
      onClick={onClick || undefined}
      width={width || '27'}
      height={height || '25'}
      viewBox="0 0 27 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ animation: 'glow-zoom 2s ease-in-out infinite' }}
    >
      <style>
        {`
            @keyframes glow-zoom {
                0% {
                    stroke-opacity: 0.7;
                    transform: scale(0.8);
                }
                50% {
                    stroke-opacity: 1;
                    transform: scale(1.1);
                }
                100% {
                    stroke-opacity: 0.7;
                    transform: scale(0.8);
                }
            }
        `}
      </style>
      <path
        d="M15.2778 25V22.0714C17.3611 21.4524 19.0394 20.2619 20.3125 18.5C21.5856 16.7381 22.2222 14.7381 22.2222 12.5C22.2222 10.2619 21.5856 8.2619 20.3125 6.5C19.0394 4.7381 17.3611 3.54762 15.2778 2.92857V0C18.1481 0.666667 20.4861 2.16071 22.2917 4.48214C24.0972 6.80357 25 9.47619 25 12.5C25 15.5238 24.0972 18.1964 22.2917 20.5179C20.4861 22.8393 18.1481 24.3333 15.2778 25ZM0 16.8214V8.25H5.55556L12.5 1.10714V23.9643L5.55556 16.8214H0ZM15.2778 18.25V6.75C16.3657 7.27381 17.2164 8.05952 17.8299 9.10714C18.4433 10.1548 18.75 11.2976 18.75 12.5357C18.75 13.75 18.4433 14.875 17.8299 15.9107C17.2164 16.9464 16.3657 17.7262 15.2778 18.25ZM9.72222 8.03572L6.73611 11.1071H2.77778V13.9643H6.73611L9.72222 17.0357V8.03572Z"
        fill={color}
      />
    </svg>
  );
};
